import { URL_CREDIT_PROFILE } from 'config'
import { apiCall } from './base'

export const getCreditScoreProfile = (tax_identification_value) =>
  apiCall(`/api/v1/credit-profiles/status/${tax_identification_value}`, {
    baseURL: URL_CREDIT_PROFILE,
    method: 'GET',
    withCredentials: true,
    immediately: true,
    params: {}
  })

// Linea de crédito
export const getCreditLines = () =>
  apiCall(`api/v1/credit-profiles/credit-lines`, {
    baseURL: URL_CREDIT_PROFILE,
    method: 'GET',
    withCredentials: true,
    immediately: true,
    params: {}
  })

export const sendCPReport = () =>
  apiCall(`api/v1/credit-profiles/export`, {
    baseURL: URL_CREDIT_PROFILE,
    method: 'GET',
    responseType: 'blob',
    withCredentials: true,
    immediately: true,
    params: {}
  })
